module.exports = __webpack_public_path__ + "img/icon-tabbar-my.a2c723d1.png";